/**
 * @generated SignedSource<<0c1f12428e968aa6b487b7cdbfa907de>>
 * @relayHash c5ec4893bcb0670caab19b1e8f5a9159
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c5ec4893bcb0670caab19b1e8f5a9159

import { ConcreteRequest } from 'relay-runtime';
export type AppointmentReviewStatus = "NEEDED" | "NONE" | "REVIEWED";
export type Flexibility = "FIXED_TIME" | "FLEXIBLE" | "NOT_EARLIER";
export type Urgency = "MEDICAL_ACUTE" | "MEDICAL_URGENT" | "NORMAL";
export type UpdateAppointmentFlexibilityInput = {
  flexibility: Flexibility;
  id: string;
};
export type useUpdateAppointmentFlexibilityMutation$variables = {
  input: UpdateAppointmentFlexibilityInput;
};
export type useUpdateAppointmentFlexibilityMutation$data = {
  readonly updateAppointmentFlexibility: {
    readonly waitingRoomAppointment: {
      readonly appointment: {
        readonly flexibility: Flexibility;
        readonly reviewStatus: AppointmentReviewStatus;
        readonly urgency: Urgency;
      };
      readonly flexibility: Flexibility;
    } | null;
  };
};
export type useUpdateAppointmentFlexibilityMutation = {
  response: useUpdateAppointmentFlexibilityMutation$data;
  variables: useUpdateAppointmentFlexibilityMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flexibility",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urgency",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reviewStatus",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateAppointmentFlexibilityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateAppointmentFlexibilityPayload",
        "kind": "LinkedField",
        "name": "updateAppointmentFlexibility",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WaitingRoomAppointment",
            "kind": "LinkedField",
            "name": "waitingRoomAppointment",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Appointment",
                "kind": "LinkedField",
                "name": "appointment",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v2/*:: as any*/),
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useUpdateAppointmentFlexibilityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateAppointmentFlexibilityPayload",
        "kind": "LinkedField",
        "name": "updateAppointmentFlexibility",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WaitingRoomAppointment",
            "kind": "LinkedField",
            "name": "waitingRoomAppointment",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Appointment",
                "kind": "LinkedField",
                "name": "appointment",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v2/*:: as any*/),
                  (v4/*:: as any*/),
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "c5ec4893bcb0670caab19b1e8f5a9159",
    "metadata": {},
    "name": "useUpdateAppointmentFlexibilityMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f628c389a5e1e0f0c5f78d81bcd0bae2";

export default node;
